/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type ChannelReviewStatus = typeof ChannelReviewStatus[keyof typeof ChannelReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelReviewStatus = {
  UNVERIFIED: 'UNVERIFIED',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
